import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useCustomerCommThread } from '@/api/hooks'
import { CustomerCommunicationDetailPage } from '@/pages/customer-communication-detail'

export const Route = createFileRoute('/_authenticated/customer-comms/$threadId')({
  staticData: { title: 'Customer Comms' },
  component: CustomerCommDetailRoute,
  // An action item opened from the Action Items page (USA-1328).
  // ``message`` opens the conversation at an email an action card links to (USA-1413).
  validateSearch: (search: Record<string, unknown>): { action?: string; message?: string } => ({
    action: typeof search.action === 'string' ? search.action : undefined,
    message: typeof search.message === 'string' ? search.message : undefined,
  }),
})

/** A customer's conversation lives under the customer (USA-1695); one with no customer stays here. */
function CustomerCommDetailRoute() {
  const { threadId } = Route.useParams()
  const search = Route.useSearch()
  const { data: thread } = useCustomerCommThread(Number(threadId))
  if (thread?.customer_group) {
    return (
      <Navigate
        to="/customers/$groupId/comms/$threadId"
        params={{ groupId: thread.customer_group.uuid, threadId }}
        search={search}
        replace
      />
    )
  }
  return (
    <CustomerCommunicationDetailPage
      threadId={Number(threadId)}
      actionUuid={search.action}
      messageId={search.message ? Number(search.message) : undefined}
    />
  )
}
